import styled from 'styled-components';

export const Container = styled.section`
  > img {
    width: 100%;
    margin-top: 40px;
  }

  @media ${({ theme }) => theme.devices.mobile} {
    margin-top: 20px;
    padding: 0 5%;
  }
`;

export const Title = styled.div`
  display: flex;
  align-items: center;

  h1 {
    font-size: 80px;
    font-family: 'Anton', sans-serif;
    text-transform: uppercase;
    margin-bottom: -12px;

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 48px;
    }
  }

  h2 {
    font-size: 36px;
    font-weight: 300;
    margin-bottom: -16px;
    margin-left: 8px;
    font-family: 'Bebas Neue', sans-serif;

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 20px;
    }
  }
`;

export const GroupPlan = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
  padding-bottom: 44px;
  gap: 32px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[200]};

  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;
    margin: 40px 0;
  }

  &:last-of-type {
    border: 0;
    padding: 0;
    margin-top: 88px;
  }
`;
